module.exports = __webpack_public_path__ + "img/shortPic.19f4ea10.png";